"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const CustomPagination_1 = require("../../../Common/CustomPagination");
const ai_1 = require("react-icons/ai");
const fa_1 = require("react-icons/fa");
const SuggestionDetailsModal_1 = __importDefault(require("../Modals/SuggestionDetailsModal"));
const comment_api_1 = require("../../../../utils/api/comments/comment.api");
const Utils_1 = require("../../../../utils/Utils");
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const EmptyAlert_1 = __importDefault(require("../../../Shared/Alerts/EmptyAlert"));
const react_bootstrap_1 = require("react-bootstrap");
const fa_2 = require("react-icons/fa");
const SuggestionDetailsButton = ({ item }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    const [updateComment] = (0, comment_api_1.useAddOrUpdateCommentMutation)();
    const handleShow = () => {
        if (item && !(item === null || item === void 0 ? void 0 : item.is_read)) {
            updateComment({ id: item.id, data: Object.assign(Object.assign({}, item), { is_read: true }) });
        }
        setShow(true);
    };
    const handleClose = () => setShow(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn btn-action-modal-icon with-tooltip", "data-tooltip-content": "Voir", onClick: handleShow },
            react_1.default.createElement(ai_1.AiFillEye, null)),
        react_1.default.createElement(SuggestionDetailsModal_1.default, { show: show, handleClose: handleClose, item: item })));
};
const DeleteCommentButton = ({ id }) => {
    const onDelete = (0, comment_api_1.UseDeleteComment)(id);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-delete", "data-tooltip-content": "Supprimer", style: { color: "#E53E3E" }, onClick: () => onDelete() },
            react_1.default.createElement(fa_1.FaTrash, null))));
};
const SuggestionAdminTable = ({ search, dateRange }) => {
    const [page, setPage] = react_1.default.useState(1);
    const [perPage, setPerPage] = react_1.default.useState(10);
    const { data, isLoading } = (0, comment_api_1.useGetCommentListQuery)({
        page: page,
        limit: perPage,
        word: search,
        date: dateRange,
    });
    const statutFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "statutformatter__wrapper" }, cell === "nouveau" ? (react_1.default.createElement("div", { className: "badge custom-badge-success" }, cell)) : (react_1.default.createElement("div", { className: "badge custom-badge-in-progress" }, cell))));
    };
    const dateFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "statutformatter__wrapper position-relative" },
            (0, Utils_1.formatDateWithRelativeDay)(cell),
            !(row === null || row === void 0 ? void 0 : row.is_read) && (react_1.default.createElement("div", { className: "custon-date-indicator" }))));
    };
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "table-actions-btn-container-commandes d-flex justify-content-start gap-3" },
            react_1.default.createElement("div", { className: "container-btn-action-icon-modal d-flex justify-content-center" },
                react_1.default.createElement(SuggestionDetailsButton, { item: row })),
            react_1.default.createElement("div", { className: "container-btn-action-icon-delete d-flex justify-content-center" },
                react_1.default.createElement(DeleteCommentButton, { id: cell }))));
    };
    const typeFormatter = (cell, row) => {
        return (cell === 'réclamation' ? (react_1.default.createElement("span", { className: "badge bg-danger" }, "r\u00E9clamation")) : cell === 'suggestion' ? (react_1.default.createElement("span", { className: "badge bg-success" }, "suggestion")) : (react_1.default.createElement("span", { className: "badge bg-danger" }, "r\u00E9clamation")));
    };
    const carteRapidoFormatter = (cell, row) => {
        return react_1.default.createElement(CarteRapidoCell, { cell: cell, row: row });
    };
    const columns = [
        {
            dataField: "date",
            text: "Date de la demande",
            formatter: dateFormatter,
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "card_number",
            text: "N° Carte Rapido",
            formatter: carteRapidoFormatter,
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "type",
            text: "Type",
            formatter: typeFormatter,
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "fullname",
            text: "Nom",
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "phone",
            text: "NUMÉRO DE TÉLÉPHONE",
            headerStyle: () => {
                return {
                    width: "200px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "status",
            text: "Statut",
            formatter: statutFormatter,
            headerStyle: () => {
                return {
                    width: "200px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "id",
            text: "Action",
            formatter: actionFormatter,
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
    ];
    return (react_1.default.createElement("div", { className: "col-lg-12" },
        react_1.default.createElement("div", { className: "admin-table" },
            !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
            !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: (data === null || data === void 0 ? void 0 : data.data) || [], columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement(EmptyAlert_1.default, { textualContent: "Aucune donn\u00E9es trouv\u00E9es" })) }),
                react_1.default.createElement("div", { className: "custom-pagination-container" },
                    react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: data === null || data === void 0 ? void 0 : data.count, page: page, onChange: (page, perPage) => {
                            setPerPage(perPage);
                            setPage(page);
                        }, perPage: perPage })))))));
};
exports.default = SuggestionAdminTable;
const CarteRapidoCell = ({ cell, row }) => {
    const [copied, setCopied] = (0, react_1.useState)(false);
    if (!cell) {
        return react_1.default.createElement("span", { className: "badge bg-secondary" }, "N/A");
    }
    const shouldTruncate = cell.length > 10;
    const displayedText = shouldTruncate ? `${cell.substring(0, 10)}...` : cell;
    const handleCopy = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.stopPropagation();
        try {
            yield navigator.clipboard.writeText(cell);
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 2000);
        }
        catch (error) {
            console.error("Erreur lors de la copie :", error);
        }
    });
    return (react_1.default.createElement("div", { className: "d-flex align-items-center gap-2" },
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: `tooltip-${(row === null || row === void 0 ? void 0 : row.id) || cell}` }, copied ? "Copié avec succès !" : cell) },
            react_1.default.createElement("span", { style: { cursor: shouldTruncate ? "pointer" : "default" } }, displayedText)),
        react_1.default.createElement("span", { onClick: handleCopy, style: { cursor: "pointer" }, title: "Copier", className: copied ? "text-success" : "" }, copied ? react_1.default.createElement(fa_2.FaCheck, { size: 14 }) : react_1.default.createElement(fa_2.FaRegCopy, { size: 14 })),
        copied && (react_1.default.createElement("small", { className: "text-success" }, "Copi\u00E9 avec succ\u00E8s"))));
};
